import React, {useContext} from 'react';

import {LandingPageV } from '../../../../widgets/LandingPageV';

import config from './config/default-blueprint.json';
import {Journey} from './illustrators/Journey';
import { ThemeContext } from '../../../../providers/theme';
import {Food} from './illustrators/Food';
import {Auth} from './illustrators/Auth';
import {CustomerEngagement} from './illustrators/CustomerEngagement';
import {Factory} from './illustrators/Factory';
import {MobileMarket} from './illustrators/MobileMarket';
import {Shopping} from './illustrators/Shopping';
import {TargetMessage} from './illustrators/TargetMessage';
import {StyleSheet} from 'react-native';
import {useViewport} from 'react-viewport-provider';
import { useHistory } from 'react-router-dom';
import { Feedback } from './illustrators/Feedback';
import { id } from 'date-fns/esm/locale';

const benefits = {
    benefitsTitle: 'Empower brands',
    benefitsDesciption:
      'Detecting counterfeits and verifying the journey of your product is now at your fingertips',
    benefitsData: [
      {
        icon: 'https://i.ibb.co/k26kSKD/protection.png',
        iconStyle: {
          tintColor: '#631A6E',
        },
        title: 'Brand Protection & Brand Value Elevation',
        desciption:
          null,
      },
      {
        icon: 'https://i.ibb.co/R4PPVmF/user-experience.png',
        iconStyle: {
          tintColor: '#631A6E',
        },
        title: 'Elevated Customer Experience (Millennials and Gen-Z)',
        desciption:
          null,
      },
      {
        icon: 'https://i.ibb.co/Lpctd9n/revenue.png',
        iconStyle: {
          tintColor: '#631A6E',
        },
        title: 'Increased Revenue (by means of offering clean, traceable product)',
        desciption:
          null,
      }
    ],
  };
  
  const alternateSections = [
    {
      key: '01',
      parallax: true,
      title: null,
      paragraph:"Blockchain-based Authenticity & Provenance Platform empowering brands to counter fraud, trace the Journey from source to consumer and engage consumers real-time",
      dotColor: '#631A6E',
      list: [ ],
    },
    {
      key: '02',
      parallax: true,
      title: null,
      paragraph:"Mobile wallet for consumers, application for supply chain actors to document proofs & API enablement layer to integrate with actors in supply chain",
      dotColor: '#631A6E',
      list: [ ],
    },
    {
      key: '03',
      parallax: true,
      title: null,
      paragraph:"Aligns with global standards including gs1 and is used by clients in US and India",
      dotColor: '#631A6E',
      list: [ ],
    },
    {
      key: '05',
      parallax: true,
      title: null,
      paragraph:"Proves Authenticity of the Product",
      dotColor: '#631A6E',
      list: [ ],
    },
    {
      key: '06',
      parallax: true,
      title: null,
      paragraph:"Provides Transparent view of Product Journey (Origin to Customer)",
      dotColor: '#631A6E',
      list: [ ],
    },
    {
      key: '07',
      parallax: true,
      title: null,
      paragraph:"Enhances after-sale experience by automating warranty process & batch recall",
      dotColor: '#631A6E',
      list: [ ],
    }
  ];
  
  const pricingTable = [
    {
      buttonText: 'Get Started',
      title: 'Bronze',
      priceText: '$100 /Month',
    },
    {
      buttonText: 'Get Started',
      title: 'Silver',
      priceText: '$400 /Month',
    },
    {
      buttonText: 'Contact Us',
      title: 'Gold',
      priceText: 'Contact Us',
    }
];
  
const pricingDetail = {
    tableHeader: [
      {
        key: 'featureCategory',
        label: 'Feature Category',
      },
      {
        key: 'feature',
        label: 'Feature',
      },
      {
        key: 'bronze',
        label: 'Bronze',
      },
      {
        key: 'silver',
        label: 'Silver',
      },
      {
        key: 'gold',
        label: 'Gold',
      }
    ],
    dataList: [
      {
        title: 'Product Stories',
        subTitle: 'Tell the stories behind  your projects',
        icon1: 'check',
        icon2: 'check',
        icon3: 'check',
      },
      {
        title: 'Proof Points',
        subTitle: 'Prove statement(eg recyclable)',
        icon1: 'check',
        icon2: 'check',
        icon3: 'check',
      },
      {
        title: 'Sharing Tools',
        subTitle: 'Publish across all digital and physical channel',
        icon1: 'check',
        icon2: 'check',
        icon3: 'check',
      },
      {
        title: 'Network Map',
        subTitle: 'Open up your supplirs market',
        icon1: 'close',
        icon2: 'close',
        icon3: 'check',
      },
      {
        title: 'Product Journey',
        subTitle: 'Show the full journey',
        icon1: 'close',
        icon2: 'close',
        icon3: 'check',
      },
    ],
  };
  
  const footer = {
    contactDetails: {
      title: 'CONTACT US',
      details: [
        {
          key: 'phone',
          label: 'Phone',
          value: '+91 80437 74543',
        },
        {
          key: 'email',
          label: 'Email',
          value: 'info@vlinder.io',
        },
      ],
    },
    socialLinks: {
      title: 'CONNECT WITH US',
      details: [
        {
          key: 'twitter',
          icon: 'https://i.ibb.co/k693xvN/twitter.png',
          link: 'https://twitter.com/GoVlinder/',
        },
        {
          key: 'linkedIn',
          icon: 'https://i.ibb.co/8jdMD1q/linkedIn.png',
          link: 'https://www.linkedin.com/company/vlinder-io/',
        },
      ],
    },
    appDownload:{
      title: "Download App",
      links:[
        {
          "key": "android",
          "icon": "https://i.ibb.co/560xTmk/android-icon.png",
          "url":"https://play.google.com/store/apps/details?id=io.vlinder.trag"
        }, 
        {
          "key": "ios",
          "icon": "https://i.ibb.co/VNtXMYT/apple-icon.png",
          "url":"https://apps.apple.com/app/id1536485775"
        }
      ]
    },
    copyright: {
      logo: 'https://i.ibb.co/VNHWjpM/vlinder-circle.png',
      footerNav: [
        {
          eventKey: 'aboutus',
          label: 'About Us',
        },
        {
          eventKey: 'terms',
          label: 'Terms And Condition',
        },
        {
          eventKey: 'privacy',
          label: 'Privacy',
        },
      ],
      copyRightText: {
        company: 'vlinder Inc.',
        poweredBy: 'vlinder',
        poweredByURL: 'https://vlinder.io/',
      },
    },
  };
  
  const HeaderMenu = [
    {
      eventKey: 'product',
      label: 'Product',
    },
    {
      eventKey: 'benefits',
      label: 'Benefits',
    },
    {
      eventKey: 'contact',
      label: 'Contact'
    }
  ];

export const Landing = () => {
    const history = useHistory();
    const {width, height, bp} = useViewport();
    const theme = useContext(ThemeContext);
    const styles = StyleSheet.create({
      containerStyle: {
        width: 1 * width,
        // height: 0.7 * height,
        backgroundColor: '#FAFBFC',
      },
      titleStyle:{
        ...theme?.typography?.logotext,
        color:'#fff'
      }
    });
    const onFooterNavSelect = (eventKey:string) => {
      console.log('foote nav item', eventKey);
      if(eventKey === 'aboutus'){
        window.open('https://provenance.wedoverify.io/')
      }
      if(eventKey === 'terms'){
        history.push('/termsandcondition');
      }
      if(eventKey === 'privacy'){
        history.push('/privacy');
      }
    };
    
    const handleIllustrator = ({
        key,
        width,
        height,
        stroke,
        main,
        highlight,
        secondary,
        tertiary,
        index,
      }) => {
        switch (key) {
          // case 'university':
          //   return <University width={width} height={height} stroke={stroke} main={main} highlight={highlight} secondary={secondary} tertiary={tertiary} />
          // case 'verifier':
          //   return <Verifier width={width} height={height} stroke={stroke} main={main} highlight={highlight} secondary={secondary} tertiary={tertiary} />
          // case 'holder':
          //   return <Reader width={width} height={height} stroke={stroke} main={main} highlight={highlight} secondary={secondary} tertiary={tertiary} />
          case 'journey':
            return (
              <Journey
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'factory':
            return (
              <Factory
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'food':
            return (
              <Food
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'auth':
            return (
              <Auth
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'customer-engagement':
            return (
              <CustomerEngagement
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'shopping':
            return (
              <Shopping
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'feedback':
            return (
              <Feedback
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'mobile-market':
            return (
              <MobileMarket
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          case 'target-message':
            return (
              <TargetMessage
                width={width}
                height={height}
                stroke={stroke}
                main={main}
                highlight={highlight}
                secondary={secondary}
                tertiary={tertiary}
              />
            );
          default:
            return null;
        }
      };
    return (
        <LandingPageV
        themeColor={"#631A6E"}
        headerContainerStyle={{backgroundColor:'#000', paddingBottom:20}}
        titleStyle={StyleSheet.flatten([styles.titleStyle])}
        bgImg={'https://i.ibb.co/KbqMfjt/slider-bg.png'}
        bgImgHeight={'80vh'}
        loginButtonTitle={'Login'}
        headerMenu={HeaderMenu}
        title={'We Do Verify'}
        onLoginButtonPress={()=>{history.push('/login')}}
        leftAvatar={'https://i.ibb.co/bWBCqc6/we-do-verify-icon.png'}
        videoLink={'https://www.youtube.com/watch?v=xhUIk3zxtoA'}
        videoButtonColor={'red'}
        videoTitle={'We do verify: Authenticate & Trace'}
        videoDescription={
          'We dod verify is a Blockchain-enabled Authenticity & Provenance Platform empowering brands to counter fraud and track the Journey of their products from source to end consumers.'
        }
        benefits={benefits}
        // pricingData={pricingTable}
        // pricingTitle={'Choose the right plan'}
        // pricingSubTitle={
        //   'Start your transparency journey today. Open up your supply chain behind a single product or the impact across your entire business.'
        // }
        renderIllustrator={handleIllustrator}
        illustratorsGroup={config.Illustrator.illustratorGroup}
        mobileillustratorsGroup={config.Illustrator.mobileIllustratorGroup}
        bodyContent={alternateSections}
        contactDetails={footer?.contactDetails}
        socialLinks={footer?.socialLinks}
        copyright={footer?.copyright}
        // parallaxBg={`${require('./assets/digicert.gif')}`} 
        //mobileParallaxBg={`${require('./assets/mobile-bg.png')}`}
        // pricingDetailData={pricingDetail}
        onFooterNavSelect={onFooterNavSelect}
      />
    )
}